import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import * as React from 'react';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import strings from 'owa-strings/owa-mail-strings';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';

let styles = require('./PeoplePickerDialog.scss');
// Properties for the persona component in the dialog
export interface PeoplePickerPersonaProps {
    userMailboxWrapper: EmailAddressWrapper;
    removePersonCallback: () => void;
}

/**
 * Functional component for people persona, takes user mailbox information and remove callback
 */
export default function PeoplePickerPersona(props: PeoplePickerPersonaProps) {
    const { Name: name, EmailAddress: emailAddress } = props.userMailboxWrapper;

    return (
        <div className={styles.attendeeContainer} key={'personaId'}>
            <div className={styles.personaContainer}>
                <div className={styles.personaControl}>
                    <PersonaControl
                        name={name}
                        emailAddress={emailAddress}
                        size={PersonaSize.size32}
                        showPersonaDetails={false}
                    />
                </div>
                <div className={styles.personaDetails}>
                    <TooltipHost content={name} id="peoplePickerPersonaName">
                        <span
                            aria-describedby="peoplePickerPersonaName"
                            className={styles.personaName}>
                            {name}
                        </span>
                    </TooltipHost>
                    <TooltipHost content={emailAddress} id="peoplePickerPersonaEmail">
                        <span
                            aria-describedby="peoplePickerPersonaEmail"
                            className={styles.personaEmail}>
                            {emailAddress}
                        </span>
                    </TooltipHost>
                </div>
            </div>
            <IconButton
                iconProps={{
                    iconName: 'Cancel',
                }}
                title={strings.removePersonaTooltipText}
                onClick={props.removePersonCallback}
            />
        </div>
    );
}
